import React from 'react'
import CommonHeader from './common/CommonHeader'
import '../torfacts.css'
import Footer from './common/Footer'

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KnowMore from './common/KnowMore';


const FAQ = () => {
  return (
    <>
    <div className="main-content">
        <CommonHeader title={'Frequently Asked Questions'} stitle={"Get answers to all your questions"} id={'1'} />
        
    </div>
    <div className='pageContent bg-light-blue'>
      <div className="main-content">
        <Accordion className='torfacts-accordion'>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          What is Torfacts?
        </AccordionSummary>
        <AccordionDetails>
           We are glad you asked. Torfacts is an online survey site. A lot of brands and companies are looking for respondents to provide their opinions and receive rewards in return. Torfacts is one such platform where you can give your opinion and earn rewards for it too.
        </AccordionDetails>
      </Accordion>
      <Accordion className='torfacts-accordion'>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          Is it free to join?
        </AccordionSummary>
        <AccordionDetails>
      Yes, it is free to join. In fact, if someone is asking you a joining fee, we would want you to report it to us.
        </AccordionDetails>
      </Accordion>

      <Accordion className='torfacts-accordion'>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3-header"
        >
          Can I refer my friends?
        </AccordionSummary>
        <AccordionDetails>
      Yes, you can invite your friends and colleagues to join and also get rewarded for it. Please click "Refer Friend" link on your dashboard to get all the details.
        </AccordionDetails>
      </Accordion>

      <Accordion className='torfacts-accordion'>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4-content"
          id="panel4-header"
        >
          What do I earn?
        </AccordionSummary>
        <AccordionDetails>
      Now in our new model, you can earn points in many ways other than just by taking the surveys. You get points by: Registering with us, By verifying your email account, For completing your profile, of course for completing any survey and to your surprise even for a disqualified survey. So we have all the reasons to get you started isn't it?
        </AccordionDetails>
      </Accordion>
     
      </div>
    </div>
    <KnowMore />
    <Footer />
    </>
  )
}

export default FAQ